import { render, staticRenderFns } from "./class_portrait.vue?vue&type=template&id=526bb793&scoped=true"
import script from "./class_portrait.vue?vue&type=script&lang=js"
export * from "./class_portrait.vue?vue&type=script&lang=js"
import style0 from "./class_portrait.vue?vue&type=style&index=0&id=526bb793&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526bb793",
  null
  
)

export default component.exports